import { render, staticRenderFns } from "./TeacherDialog.vue?vue&type=template&id=05b6ac2f&scoped=true"
import script from "./TeacherDialog.vue?vue&type=script&lang=js"
export * from "./TeacherDialog.vue?vue&type=script&lang=js"
import style0 from "./TeacherDialog.vue?vue&type=style&index=0&id=05b6ac2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b6ac2f",
  null
  
)

export default component.exports